export default {
  mainBackground: (layout) => ({
    width: '100%',
    background: `linear-gradient(
      rgba(223,221,222, 1),
      rgba(192,190,191, 0.85)),url('${layout?.backgroundImage}')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    clipPath: [
      'polygon(50% 93%, 100% 90%, 100% 0, 0 0, 0 90%)',
      'polygon(50% 93%, 100% 85%, 100% 0, 0 0, 0 85%)',
    ],
    height: '100%',
  }),
}
